// extracted by mini-css-extract-plugin
export default {"mCard":"GC-z","image":"HC-z","imageNoBackground":"IC-z","imageHasCategory":"JC-z","fullWidth":"KC-z"};